import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Table,
  TableCell,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from "@material-ui/core";
import exportToExcel from '../../../utils/convertJsonToExcel.js';
import TablePagination from "@material-ui/core/TablePagination";
import Skeleton from "@mui/material/Skeleton";
import { sendEmailEvents } from "../../../store/action/communicationChannel";
import { getAllUsers, getAllAuthorities ,getUserGroups, createUser ,addAuthorityToUser, addDAAQToUser ,createDAAQ,AddUserGroupToUser ,deleteUser ,updateUser ,RemoveUserGroupFromUser , RemoveDAAQFromUser ,RemoveAuthorityFromUser, checkDaaqExist, sendNewPasswordEmail } from "../../../store/action/user.js";
import { CheckPersonExistence, createPerson ,createCommunicationChannel,AddCommunicationChannelToParty ,getPartyDetails,getPersonDetails ,updatePerson ,updateCommunicationChannel, deletePerson } from "../../../store/action/party.js";
import "./User.css";
import { ManagementTypes } from '../../../utils/ManagementTypes';
import { useDispatch } from "react-redux";
import DialogContentText from "@mui/material/DialogContentText";
import {
  Accordion,
  AccordionPanel,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";
import Autocomplete from "@mui/material/Autocomplete";
import { translateAuthorities } from "../../../utils/translateAuthorities.js";
import { getAllAgency } from "../../../store/action/claim.js";
import generatePassword from "../../../utils/generatePassword.js"
import Slide from "@mui/material/Slide";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {validateInput} from "../../../utils/inputValidation";
import ErrorsAlert from "../../../utils/errorsAlert";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { styled } from '@mui/material/styles';
import Switch from "@material-ui/core/Switch";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "85vh",
  },
  tableCellSmall: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "21px",
    color: "rgba(70, 78, 95, 1)",
    borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
  },
  paper: {
    width: "100%",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
  tableWrapper: {
    padding: "40px",
  },
  tableHeadRows: {
    whiteSpace: "nowrap",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "18px",
    color: "rgba(181, 181, 195, 1)",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    padding: "1%",
  },

  tableSortLabel: {
    color: "rgba(32, 29, 35, 1)",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "18px",
  },
  titre: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(63, 66, 84, 1)",
  },
  titreLabel: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "rgba(32, 18, 70, 1)",
  },
  tablePagination: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  dateRangeContainer: {
    display: "flex",
    alignItems: "center",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    padding: "5px 10px",
  },
  dateContainer: {
    border: "none",
    outline: "none",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    fontFamily: "Poppins",
    paddingLeft: "5px",
  },
  inputContainer: {
    border: '0.61px solid rgba(226, 217, 239, 1)',
    background: 'rgba(255, 255, 255, 1)',
    width: '234px',
    height: '30px',
    borderRadius: 5,
    marginLeft: '20px',
},
  viewBtn: {
    width: "40px",
    height: "34px",
    borderRadius: "6px",
    backgroundColor: "rgba(240, 243, 199, 1)",
    border: 0,
    lineHeight: "18px",
    color: "rgba(187, 200, 8, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  taskNameColumn: {
    width: "114px",
    height: "20px",
    gap: "0px",
    fontFamily: "Poppins",
    fontSize: "10.17px",
    fontWeight: 500,
    textAlign: "left",
    color: "rgba(187, 200, 8, 1)",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  tableContent: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 400,
    //lineHeight: 19.6,
    textAlign: "left",
    color: "rgba(32, 29, 35, 0.8)",
    paragraph: {
      lineHeight: "32.69px",
    },
  },
  sinistres: {
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: 600,
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
  },
  dropdownMenu: {
    position: "absolute",
    zIndex: 1,
    backgroundColor: "white",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    //boxShadow: theme.shadows[5],
    marginRight: "110px",
    borderRadius: 6,
  },
  dropdownItem: {
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  naText: {
    color: "rgb(145, 145, 145)",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperModal: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    border: "none",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(2, 4, 3),
    width: "459px",
    height: "175px",
  },
  modalTitle: {
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "21px",
    textAlign: "left",
    marginBottom: "16px",
  },
  // dialogTitle: {
  //   fontFamily: "Poppins",
  //   fontWeight: 500,
  //   fontSize: 15,
  //   color: "rgba(63, 66, 84, 1)",
  //   backgroundColor: "white",
  //   borderBottom: "1px solid #E5EAEE",
  // },
  line: {
    height: "2px",
    backgroundColor: "rgba(243, 246, 249, 1)",
    width: "100%",
    marginBottom: "16px",
  },
  selectModal: {
    width: "400px",
    height: "36px",
    borderRadius: "4px",
    border: "1px solid rgba(222, 222, 222, 1)",
  },
  CancelStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    color: "rgb(255, 54, 54)",
    backgroundColor: " rgb(255, 229, 229)",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
    cursor: "pointer",
  },
  ExportStyle: {
    border: "0.96px solid rgba(187, 200, 8, 1)",
    color: "rgba(187, 200, 8, 1)",
    width: "64px",
    height: "27px",
    fontFamily: "Poppins",
    fontSize: "12.76px",
    fontWeight: 400,
    lineHeight: "19.14px",
    background: "rgba(255, 255, 255, 1)",
    margin: "0 1rem",
    cursor: "pointer",
  },
  ajouterStyle: {
    marginLeft: "20px",
    width: "64px",
    height: "27px",
    backgroundColor: "rgba(187, 200, 8, 1)",
    color: "rgba(255, 255, 255, 1)",
    borderRadius: "5.38px",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
    cursor: "pointer",
  },
  TextContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 15px",
  },
  dialogContent: {
    overflowY: "auto",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  cardText: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 400,
    color: "rgba(70, 78, 95, 1)",
  },
  cardValue: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    color: "rgba(24, 28, 50, 1)",
    textAlign: "Right",
  },
  styleInput: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    color: "rgba(24, 28, 50, 0.58)",
    lineHeight: "21px",
    padding: "5px",
    width: "240px",
    height: "36px",
    borderRadius: "4px",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "8px",
    width: "100%",
    height: "680px",
    border: "0.61px solid rgba(226, 217, 239, 1)",
  },
  dialogPaper: {
    width: "700px",
    overflow: "hidden",
  },
  selectInput: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "148px",
    height: "29.69px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  selectInputDialog: {
    width: "100%",
    border: "0",
    padding: "5px",
    background: "rgba(243, 246, 249, 1)",
    height: "29.69px",
    borderRadius: 5,
    alignItems: 'center', // Vertically center the text
    justifyContent: 'center', // Horizontally center the text

  },
  selectInputFiltre: {
    width: "100%",
    border: "0",
    height: "29.69px",
    borderRadius: 5,
    alignItems: 'center', // Vertically center the text
    justifyContent: 'center', // Horizontally center the text

  },
  optionLabel: {
    width: "150px",
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  dialogTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 15,
    color: "rgba(63, 66, 84, 1)",
    backgroundColor: "white",
    borderBottom: "1px solid #E5EAEE",
  },
  autocompleteTag: {
    fontFamily: 'Poppins, sans-serif',
    backgroundColor: 'rgba(240, 243, 199, 1)',
    color: 'rgba(187, 200, 8, 1)',
    border: 'none',
    fontSize: '0.75rem',
    padding: '2px 6px',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2px',
    borderRadius: '16px',
    display: 'inline-block',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  optionItem: {
    width: "100%",
    padding: theme.spacing(1),
    cursor: "pointer",
    backgroundColor: "white",
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    specialInput: {
      color: "rgba(24, 28, 50, 0.58)",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: 500,
      textAlign: "right",
      backgroundColor: "rgba(243, 246, 249, 1)",
      border: "none",
      width: "209px",
      height: "28px",
    },
    
  },
}));
export default function UsersList(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [nomFiltre, setNomFiltre] = useState("");
  const [prenomFiltre, setPrenomFiltre] = useState("");
  const [usersFilter, setUsersFilter] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [nomGroup, setNomGroup] = useState([]);
  const [showLockedOnly, setShowLockedOnly] = useState(false);
  const [openUnlockDialog, setOpenUnlockDialog] = useState(false);
  const [userToUnlock, setUserToUnlock] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedUserEdit, setSelectedUserEdit] = useState(null);
  
  const [isEditing, setIsEditing] = useState(false);
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [identity, setIdentity] = useState("");
  const [groupDAAQs, setGroupDAAQs] = useState([]);
  const [groupAuthorities, setGroupAuthorities] = useState([]);
  const [groupAgencies, setGroupAgencies] = useState([]);
  const [authorities, setAuthorities] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [selectedDAAQs, setSelectedDAAQs] = useState([]);  
  const [managementTypes, setManagementTypes] = useState([]);
  const [selectedAgencies, setSelectedAgencies] = useState([]); 
  const [selectedGroup, setSelectedGroup] = useState([]); 
  const [selectedAuthorities, setSelectedAuthorities] = useState([]); 
  const [isRequestInProgress, setIsRequestInProgress] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [errors, setErrors] = useState([]);

  const headRows = [
    { id: "nom", align: "left", label: "Nom & Prénom", width: "20%" },
    { id: "email", align: "left", label: "Email", width: "20%" },
    { id: "tel", align: "left", label: "Tél", width: "10%" },
    {
      id: "groups",
      align: "left",
      label: "Groups",
      width: "30%",
    },
    { id: "", align: "center", label: "", width: "20%" },
  ];
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
  const phoneRegex = /^[0-9]{8}$/;
  const handleNomGroupeChange = (event, newValue) => {
    setNomGroup(newValue);
  };
  const handleNomChange = (e) =>
    setNomFiltre(e.target.value.toLowerCase());
  const handlePrenomChange = (e) =>
    setPrenomFiltre(e.target.value.toLowerCase());

  const handleClickDeleteOpen = (user) => {
    setUserToDelete(user);
    setOpenConfirm(true);
  };
  const handleCloseConfirm = () => {
    setOpenConfirm(false);
    setUserToDelete(null);
  };

      function handleExport() {
        if (!Array.isArray(usersFilter)) {
            console.error("users is not an array");
            return;
        } 
        const dataExportToExcel = usersFilter.map(data => {
             
    
            return {
              username : data.username || null,
              firstName :data.firstName || null,
              lastName: data.lastName || null,
              email : data.email || null,
              phoneNumber : data.phoneNumber ||null,
              DAAQs : data.personalDAAQs.map(DAAQs => DAAQs.label).join(' ; ') || null ,
              Authorities : data.personalAuthorities.map(Authorities => Authorities.label).join(' ; ') || null,
              Groups   : data.userGroups.map(group => group.label).join(' / ') || null 
            };
        });
    
         exportToExcel(dataExportToExcel, 'Users.xlsx');
    }
  const handleCloseDialog = () => {
    setLastName('');
    setFirstName('');
    setPhoneNumber('');
    setEmail('');
    setIdentity(''); 
    setSelectedGroup([]);
    setSelectedDAAQs([]);
    setSelectedAgencies([]);
    setSelectedAuthorities([]);
    setOpen(false);
  };
 
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const fetchAuthorities = async () => {
    const authorities = await dispatch(getAllAuthorities());
    setAuthorities(authorities);
  };
  const filterUsers = () => {
    let filteredUsers = usersData;
    if (nomFiltre) {
      filteredUsers = filteredUsers.filter((user) =>
        (user.firstName || '').toLowerCase().includes(nomFiltre)
      );
    }
    if (prenomFiltre) {
      filteredUsers = filteredUsers.filter((user) =>
        (user.lastName || '').toLowerCase().includes(prenomFiltre)
      );
    }
    if (nomGroup.length > 0) {
      filteredUsers = filteredUsers.filter(user =>
        user.userGroups.some(group =>
          nomGroup.some(filterGroup =>
              group.uid === filterGroup.uid && group.label === filterGroup.label
          )
      )
  );

    }
    if (showLockedOnly) {
      filteredUsers = filteredUsers.filter((user) => user.accountLocked === true);
    }
      setUsersFilter(filteredUsers);

  };

  const handleLockedSwitchChange = (event) => {
    setShowLockedOnly(event.target.checked);
  };

  const handleOpenUnlockDialog = (user) => {
    setUserToUnlock(user);
    setOpenUnlockDialog(true);
  };

  const handleCloseUnlockDialog = () => {
    setOpenUnlockDialog(false);
    setUserToUnlock(null);
  };

  const handleConfirmUnlock = async () => {
    if (!userToUnlock?._id) {
      toast.error("Utilisateur introuvable.");
      return;
    }
    try {
      const result = await updateUser(userToUnlock._id, {
        firstName: userToUnlock.firstName,
        lastName: userToUnlock.lastName,
        email: userToUnlock.email,
        accountExpired: userToUnlock.accountExpired || false,
        accountLocked: false,
        phoneNumber: userToUnlock.phoneNumber,
        numberOfAttempts: 0,
      });
      // updateUser avale les erreurs HTTP : vérifier le résultat avant d'envoyer le mot de passe
      if (!result || result.updatedUser?.accountLocked !== false) {
        throw new Error("Le compte n'a pas été déverrouillé");
      }
      await sendNewPasswordEmail(userToUnlock._id);
      toast.success("Compte déverrouillé avec succès. Un email avec le nouveau mot de passe a été envoyé.");
      handleCloseUnlockDialog();
      fetchUsers();
    } catch (error) {
      console.error("Erreur lors du déverrouillage de l'utilisateur:", error);
      toast.error("Erreur lors du déverrouillage de l'utilisateur.");
    }
  };
  // Les experts (groupe EXPERT_group) ont leur propre écran — exclus de la liste,
  // de l'export Excel et des choix de groupe du formulaire
  const EXPERT_GROUP_LABEL = 'EXPERT_group';
  const isExpertUser = (user) =>
    (user.userGroups || []).some((group) => group.label === EXPERT_GROUP_LABEL);

  const fetchUsers = async () => {
    const users = await dispatch(getAllUsers());
    const nonExperts = Array.isArray(users) ? users.filter((u) => !isExpertUser(u)) : [];
    // usersFilter est recalculé par le useEffect de filtrage (dépendance usersData)
    setUsersData(nonExperts);
    setLoading(false);
  };


  const fetchUserGroups = async () => {
    const groups = await dispatch(getUserGroups());
    setUserGroups(Array.isArray(groups) ? groups.filter((g) => g.label !== EXPERT_GROUP_LABEL) : groups);
  };
  const fetchAgencies = async () => {
    const ag = await dispatch(getAllAgency());
    setAgencies(ag);
  };
  const getManagementTypeFromDaaqLabel = (daaqLabel) => {
    if (!daaqLabel) return "Unknown";
    const parts = daaqLabel.split("/");

    if (parts.length >= 3) {
      const label = parts[2].toUpperCase();  
      const managementType = managementTypes.find((item) => item.label === label);
      return managementType ? managementType.label : "Unknown";
    }
    return "Unknown";
  };
  
  const getAgencyFromDaaqLabel = (daaqLabel) => {
    if (!daaqLabel) return "Unknown";
  
    const parts = daaqLabel.split("/");
  
    if (parts.length >= 4) {
      const agencyLabel = parts[3];
       const agency = agencies.find((agency) => agency.label === agencyLabel);
      return agency ? agency.label : "Unknown";
    }
  
    return "Unknown";
  };
  const handleAddUser = () => {
    setSelectedUserEdit();
    setLastName('');
    setFirstName('');
    setPhoneNumber('');
    setEmail('');
    setIdentity(''); 
    setSelectedGroup([]);
    setSelectedDAAQs([]);
    setSelectedAgencies([]);
    setSelectedAuthorities([]);
    setIsEditing(false);
    setOpen(true);
  };

  const handleEditUser = (user) => {
    console.log("Edit user : ", user);
    setSelectedUserEdit(user);
    setIsEditing(true);
    setLastName(user.lastName);
    setFirstName(user.firstName);
    setPhoneNumber(user.phoneNumber);
    setEmail(user.email);
    setIdentity(user.identity); 
      const updatedUsergroup = user.userGroups
      .map((usergroup) => ({
        label: usergroup.label,
      }))
    setSelectedGroup(updatedUsergroup);
      const updatedDAAQs = user.personalDAAQs
          .map((daq) => ({
            label: getManagementTypeFromDaaqLabel(daq.readDAAQ).toUpperCase(),
          }))
          .filter(
            (value, index, self) =>
              value.label !== "Unknown" &&  
              index === self.findIndex((t) => t.label === value.label)  
          );
    setSelectedDAAQs(updatedDAAQs);
        const updatedAgencies = user.personalDAAQs
          .map((daq) => ({
            label: getAgencyFromDaaqLabel(daq.readDAAQ),
          }))
          .filter(
            (value, index, self) =>
              value.label !== "Unknown" &&  
              index === self.findIndex((t) => t.label === value.label)  
          );
    setSelectedAgencies(updatedAgencies);
        const updatedAuthorities = user.personalAuthorities
        .map((authorities) => ({
          label: authorities.label,
        }))
    setSelectedAuthorities(updatedAuthorities);
    setOpen(true);
  };
  const handleGroupsChange = (event, newValue) => {
    setSelectedGroup(newValue);
  };
  const handleDAAQChange = (event, newValue) => {
    setSelectedDAAQs(newValue);
  };
  const handleAgencyChange = (event, newValue) => {
    setSelectedAgencies(newValue);
  };
  const handleAuthorityChange = (event, newValue) => {
    setSelectedAuthorities(newValue);
  };
  const StyledSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#65C466',
          opacity: 1,
          border: 0,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 13,
      backgroundColor: '#E9E9EA',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));

  const getPasswordExpirationDate = () => {
     // Créer une nouvelle date (date actuelle)
     const currentDate = new Date();
     // Ajouter 1 an
    currentDate.setFullYear(currentDate.getFullYear() + 1);
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
    const year = currentDate.getFullYear();
    return `${month}-${day}-${year}`;
  };
  const handleSubmitAdd = async () => {
    // Validation hors du try : un return dans le try déclenchait le finally qui fermait le dialogue
    if (!lastName || !firstName || !phoneNumber || !email  || !identity || selectedGroup.length === 0 || selectedDAAQs.length === 0 || selectedAgencies.length === 0 || selectedAuthorities.length === 0) {
      alert("Veuillez remplir tous les champs obligatoires : nom d'utilisateur, prénom, numéro de téléphone, groupe sélectionné, DAAQs sélectionnés, agences sélectionnées et autorités sélectionnées.");
      return;
    }
    if(!emailRegex.test(email) ) // Check if email is valid
    {
      alert("L'adresse e-mail saisie est invalide. Veuillez entrer une adresse e-mail valide.");
      return;
    }
    if (!phoneRegex.test(phoneNumber)) { // Check if phone number is valid
      alert("Le numéro de téléphone saisi est invalide. Veuillez entrer un numéro de téléphone valide (10 chiffres).");
      return;
    }

    setIsRequestInProgress(true);
    const partyData = {
      "birthDate": "1995-01-01",
      "name": firstName,
      "daaq":"/",
      "code":identity,
      "lastName": lastName,
      "identityNumber": identity,
      "additionalData":{
      }
    }
    const communicationChannels=[ {
        "type": "PHONECONTACT",
        "value": phoneNumber
     },
     {
      "type": "EMAILCONTACT",
      "value": email
      }];
    const userData = {
        "username":firstName.replaceAll(' ', '')+"_"+lastName.replaceAll(' ', ''),
        "firstName": firstName,
        "lastName": lastName,
        "email": email,
        "accountExpired": false,
        // Un compte créé verrouillé ne peut pas se connecter avec le mot de passe envoyé par email
        "accountLocked": false,
        "phoneNumber": phoneNumber,
        "password": generatePassword(),
        "passwordExpirationDate":getPasswordExpirationDate(),
        "associatedPartyUid":""
    }

    let createdPersonUid = null;
    let newUser = null;
    try {
      let personApi = await CheckPersonExistence(partyData);
      if (!personApi) {
        personApi = await createPerson(partyData);
        if (!personApi) {
          throw new Error('Error Create Person');
        }
        createdPersonUid = personApi.uid;
        // Canaux créés uniquement pour une nouvelle personne : une personne existante a déjà les siens
        await Promise.all(communicationChannels.map(async (channelData) => {
          const channel = await dispatch(createCommunicationChannel(channelData));
          await AddCommunicationChannelToParty(personApi.uid, channel._id);
        }));
      }
      userData.associatedPartyUid = personApi.uid;

      newUser = await dispatch(createUser(userData));
      if (!newUser || !newUser._id) {
        throw new Error("Failed to create user");
      }

      // ms-user envoie déjà l'email d'identifiants à la création : celui-ci ne doit pas bloquer le flux
      try {
        await dispatch(sendEmailEvents({
          templateId: "674e19a1a4d434916dc9be54",
          email: userData.email,
          parameters: {
            prenom: userData.lastName,
            nom: userData.firstName,
            username: userData.username,
            password: userData.password,
          },
        }));
      } catch (emailError) {
        console.error("[handleSubmitAdd] email non envoyé :", emailError);
      }

      for (const group of selectedGroup) {
        const added = await dispatch(AddUserGroupToUser(newUser._id, group.uid));
        if (!added) throw new Error(`Failed to add group ${group.label}`);
      }

      const agencies = selectedAgencies.length > 0 ? selectedAgencies : [null];
      for (const daaq of selectedDAAQs) {
        for (const agency of agencies) {
          const label = `${daaq.label ?? ''}_${agency?.label ?? ''}`.toLowerCase();
          const readDAAQ = agency
            ? `/claim/${daaq.label.toLowerCase()}/${agency.label}`
            : `/claim/${daaq.label.toLowerCase()}`;
          let newDAAQ = await dispatch(checkDaaqExist(readDAAQ));
          if (!newDAAQ) {
            newDAAQ = await dispatch(createDAAQ({ label, readDAAQ, updateDAAQ: readDAAQ }));
          }
          if (!newDAAQ || !newDAAQ.uid) {
            throw new Error(`Failed to create DAAQ ${readDAAQ}`);
          }
          const addedDaaq = await dispatch(addDAAQToUser(newUser._id, newDAAQ.uid));
          if (!addedDaaq) throw new Error(`Failed to add DAAQ ${readDAAQ}`);
        }
      }

      for (const authority of selectedAuthorities) {
        const added = await dispatch(addAuthorityToUser(newUser._id, authority.uid));
        if (!added) throw new Error(`Failed to add authority ${authority.label}`);
      }

      toast.success("Utilisateur créé avec succès");
      handleCloseDialog();
      fetchUsers();
    } catch (error) {
      console.error("[handleSubmitAdd]", error);
      toast.error("Échec de la création de l'utilisateur");
      // Rollback : un compte incomplet et une personne orpheline bloqueraient toute nouvelle tentative
      try {
        if (newUser?._id) {
          await dispatch(deleteUser(newUser._id));
        }
        if (createdPersonUid) {
          await deletePerson(createdPersonUid);
        }
      } catch (rollbackError) {
        console.error("[handleSubmitAdd] rollback", rollbackError);
      }
    } finally {
      setIsRequestInProgress(false);
    }
  };

const updateUserGroups = async (selectedUserEdit, selectedGroup) => {
  const currentGroupLabels = new Set(selectedUserEdit.userGroups.map(g => g.label));
  const selectedGroupLabels = new Set(selectedGroup.map(g => g.label));

  const hasChanges =
    currentGroupLabels.size !== selectedGroupLabels.size ||
    [...selectedGroupLabels].some(label => !currentGroupLabels.has(label));

  if (!hasChanges) {
    console.log("Aucun changement détecté dans les groupes. Pas de mise à jour nécessaire.");
    return;
  }

  // Ajout des nouveaux groupes
  for (const group of selectedGroup) {
    if (!selectedUserEdit.userGroups.some(userGroup => userGroup.label === group.label)) {
      await dispatch(AddUserGroupToUser(selectedUserEdit._id, group.uid));
      console.log(`userGroup ${group.label} ajouté`);
    }
  }

  // Suppression des groupes obsolètes
  for (const userGroup of selectedUserEdit.userGroups) {
    if (!selectedGroupLabels.has(userGroup.label)) {
      await dispatch(RemoveUserGroupFromUser(selectedUserEdit._id, userGroup.uid));
      console.log(`userGroup ${userGroup.label} supprimé`);
    }
  }
};


const updateDAAQUser = async (selectedUserEdit, selectedDAAQs, selectedAgencies) => {
  const existingDAAQUIDs = new Set(selectedUserEdit.personalDAAQs.map(d => d.uid));
  const desiredDAAQUids = new Set();
  const agenciesToUse = selectedAgencies.length > 0 ? selectedAgencies : [null];

  // Un DAAQ que le formulaire ne sait pas représenter (typologie ou agence hors référentiel) ne doit jamais être retiré
  const isRepresentable = (personalDAAQ) => {
    const parts = (personalDAAQ.readDAAQ || '').split('/');
    if (getManagementTypeFromDaaqLabel(personalDAAQ.readDAAQ) === "Unknown") return false;
    return parts.length <= 3 || getAgencyFromDaaqLabel(personalDAAQ.readDAAQ) !== "Unknown";
  };

  const expectedLabels = new Set();
  for (const daaq of selectedDAAQs) {
    for (const agency of agenciesToUse) {
      expectedLabels.add(`${daaq.label ?? ''}_${agency?.label ?? ''}`.toLowerCase());
    }
  }
  const existingLabels = new Set(
    selectedUserEdit.personalDAAQs.filter(isRepresentable).map(d => (d.label || '').toLowerCase())
  );
  const labelsChanged =
    expectedLabels.size !== existingLabels.size ||
    [...expectedLabels].some(label => !existingLabels.has(label));
  if (!labelsChanged) {
    return;
  }

  for (const daaq of selectedDAAQs) {
    for (const agency of agenciesToUse) {
      const label = `${daaq.label ?? ''}_${agency?.label ?? ''}`.toLowerCase();
      const readDAAQ = agency
        ? `/claim/${daaq.label.toLowerCase()}/${agency.label}`
        : `/claim/${daaq.label.toLowerCase()}`;

      let newDAAQ = await dispatch(checkDaaqExist(readDAAQ));
      if (!newDAAQ) {
        newDAAQ = await dispatch(createDAAQ({ label, readDAAQ, updateDAAQ: readDAAQ }));
      }
      if (!newDAAQ || !newDAAQ.uid) {
        throw new Error(`Failed to create DAAQ ${readDAAQ}`);
      }
      desiredDAAQUids.add(newDAAQ.uid);

      if (!existingDAAQUIDs.has(newDAAQ.uid)) {
        const added = await dispatch(addDAAQToUser(selectedUserEdit._id, newDAAQ.uid));
        if (!added) throw new Error(`Failed to add DAAQ ${readDAAQ}`);
      }
    }
  }

  for (const personalDAAQ of selectedUserEdit.personalDAAQs) {
    if (!desiredDAAQUids.has(personalDAAQ.uid) && isRepresentable(personalDAAQ)) {
      const removed = await dispatch(RemoveDAAQFromUser(selectedUserEdit._id, personalDAAQ.uid));
      if (!removed) throw new Error(`Failed to remove DAAQ ${personalDAAQ.readDAAQ}`);
    }
  }
};


  
const updateAuthority = async (selectedUserEdit, selectedAuthority) => {
  const currentAuthorityLabels = new Set(selectedUserEdit.personalAuthorities.map(a => a.label));
  const selectedAuthorityLabels = new Set(selectedAuthority.map(a => a.label));

  // Vérification de changement
  const hasChanges =
    currentAuthorityLabels.size !== selectedAuthorityLabels.size ||
    [...selectedAuthorityLabels].some(label => !currentAuthorityLabels.has(label));

  if (!hasChanges) {
    console.log("Aucun changement détecté dans les autorités. Pas de mise à jour nécessaire.");
    return;
  }

  // Ajout des nouvelles autorités
  for (const authority of selectedAuthority) {
    if (!selectedUserEdit.personalAuthorities.some(personalAu => personalAu.label === authority.label)) {
      await dispatch(addAuthorityToUser(selectedUserEdit._id, authority.uid));
      console.log(`authority ${authority.label} ajoutée`);
    }
  }

  // Suppression des anciennes autorités
  for (const personalAu of selectedUserEdit.personalAuthorities) {
    if (!selectedAuthorityLabels.has(personalAu.label)) {
      await dispatch(RemoveAuthorityFromUser(selectedUserEdit._id, personalAu.uid));
      console.log(`authority ${personalAu.label} supprimée`);
    }
  }
};

const updateUserIfChanged = async (selectedUserEdit, userData) => {
  const keysToCheck = ['firstName', 'lastName', 'phoneNumber', 'email'];

  const hasChanges = keysToCheck.some(
    key => selectedUserEdit[key] !== userData[key]
  );

  if (!hasChanges) {
    return;
  }

  // updateUser avale les erreurs HTTP et renvoie undefined : remonter l'échec à l'appelant
  const updated = await updateUser(selectedUserEdit._id, userData);
  if (!updated) {
    throw new Error(`Failed to update user ${selectedUserEdit.username}`);
  }
};

  const handleSubmitEdit = async () => {
    // Validation hors du try : un return dans le try déclenchait le finally qui fermait le dialogue
    if (!lastName || !firstName || !phoneNumber || !email  ) {
      alert("Veuillez remplir tous les champs obligatoires : nom d'utilisateur, prénom, numéro de téléphone, groupe sélectionné, DAAQs sélectionnés, agences sélectionnées et autorités sélectionnées.");
      return;
    }
    if(!emailRegex.test(email) ) // Check if email is valid
    {
      alert("L'adresse e-mail saisie est invalide. Veuillez entrer une adresse e-mail valide.");
      return;
    }
    if (!phoneRegex.test(phoneNumber)) { // Check if phone number is valid
      alert("Le numéro de téléphone saisi est invalide. Veuillez entrer un numéro de téléphone valide (10 chiffres).");
      return;
    }

    setIsRequestInProgress(true);
    // Uniquement les champs modifiables ici : accountLocked, password et associatedPartyUid ne doivent jamais être renvoyés
    const userData = { firstName, lastName, email, phoneNumber };
    const partyData = { name: firstName, lastName };
    const communicationChannels = [
      { "type": "PHONECONTACT", "value": phoneNumber },
      { "type": "EMAILCONTACT", "value": email },
    ];

    try {
      if (selectedUserEdit.associatedPartyUid) {
        const person = await getPartyDetails(selectedUserEdit.associatedPartyUid);
        if (!person) {
          throw new Error(`Person ${selectedUserEdit.associatedPartyUid} not found`);
        }
        for (const channel of communicationChannels) {
          const existingChannel = (person.partyCommunicationChannels || []).find(
            (ch) => ch.communicationChannel?.type === channel.type
          );
          if (!existingChannel) {
            const channelData = await dispatch(createCommunicationChannel(channel));
            await AddCommunicationChannelToParty(person.uid, channelData._id);
          } else if (existingChannel.communicationChannel.value !== channel.value) {
            // updateCommunicationChannel est une fonction async simple, pas un thunk : ne pas passer par dispatch
            const updated = await updateCommunicationChannel(existingChannel.communicationChannel._id, channel);
            if (!updated) {
              throw new Error(`Failed to update ${channel.type}`);
            }
          }
        }
        await dispatch(updatePerson(selectedUserEdit.associatedPartyUid, partyData));
      }

      await updateUserIfChanged(selectedUserEdit, userData);
      await updateUserGroups(selectedUserEdit, selectedGroup);
      await updateDAAQUser(selectedUserEdit, selectedDAAQs, selectedAgencies);
      await updateAuthority(selectedUserEdit, selectedAuthorities);

      toast.success("Utilisateur modifié avec succès");
      handleCloseDialog();
      fetchUsers();
    } catch (error) {
      console.error("[handleSubmitEdit]", error);
      toast.error("Échec de la modification de l'utilisateur");
    } finally {
      setIsRequestInProgress(false);
    }
  };

  const handleConfirmDelete = async () => {
    if (!userToDelete) return;
    let personError = false;
    try {
      setIsRequestInProgress(true);
      const deleted = await dispatch(deleteUser(userToDelete._id));
      if (!deleted) {
        throw new Error("deleteUser failed");
      }

      const partyUid = userToDelete.associatedPartyUid;
      if (partyUid) {
        // Ne supprimer la personne ms-party que si aucun autre compte (experts compris) ne pointe dessus
        const allUsers = await dispatch(getAllUsers());
        const stillReferenced = Array.isArray(allUsers) && allUsers.some((u) => u.associatedPartyUid === partyUid);
        if (!stillReferenced) {
          try {
            await deletePerson(partyUid);
          } catch (error) {
            personError = true;
            console.error("[handleConfirmDelete] deletePerson", error);
          }
        }
      }

      if (personError) {
        toast.error("Utilisateur supprimé, mais la fiche personne n'a pas pu être supprimée");
      } else {
        toast.success("Utilisateur supprimé avec succès");
      }
    } catch (error) {
      console.error("[handleConfirmDelete]", error);
      toast.error("Échec de la suppression de l'utilisateur");
    } finally {
      setIsRequestInProgress(false);
      setOpenConfirm(false);
      setUserToDelete(null);
      fetchUsers();
    }
  };

  useEffect(() => {
    setManagementTypes(ManagementTypes);
     
    fetchUserGroups();
    fetchAuthorities();
    fetchAgencies();
    fetchUsers();
  }, [dispatch]);
  
  useEffect(() => {
    filterUsers();
  }, [usersData, nomFiltre, prenomFiltre  , nomGroup, showLockedOnly]);

  const truncateLabel = (label) =>
    label.length > 14 ? `${label.substring(0, 12)}..` : label;

  function handlePhoneNumberChange(event) {
    const allowedChars = /^[0-9]+$/;
    const newValue = event.target.value.replace(/[^0-9]/g, "");

    if (newValue.length > 9) {
      return;
    }
    setPhoneNumber(newValue);
  }


  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "40px",
            }}
          >
            <div className={classes.titre} style={{ width: "20%" }}>
              Liste des utilisateur
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "80%",
              //  justifyContent: "flex-end",
              }}
            >
              <div
                className={classes.titre}
                style={{ marginRight: "15px", whiteSpace: "nowrap" }}
              >
                Filtrer par
              </div>
              <div
  className={classes.titreLabel}
  style={{
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
  }}
>
  Groupe

  <Autocomplete
    multiple
    id="TypologieFiltreGroupe"
    options={userGroups}
    value={nomGroup}
    style={{ width: "300px", marginLeft: "10px" }}
    onChange={handleNomGroupeChange}
    getOptionLabel={(option) => option.label}
    renderOption={(props, option) => (
      <li {...props} className={`${props.className} ${classes.optionItem}`}>
        {option.label}
      </li>
    )}
    renderTags={(tagValue, getTagProps) => {
      const visibleTag = tagValue[0];
      const hiddenTags = tagValue.slice(1);
      return (
        <>
          {visibleTag && (
            <span
              {...getTagProps({ index: 0 })}
              className={classes.autocompleteTag}
            >
              {truncateLabel(visibleTag.label)}
            </span>
          )}
          {hiddenTags.length > 0 && (
            <span
              className={classes.autocompleteTag}
              title={hiddenTags.map((tag) => tag.label).join(", ")}
            >
              ... ({hiddenTags.length})
            </span>
          )}
        </>
      );
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        style={{ marginLeft: "30px" }}
        className={classes.inputContainer}
        InputProps={{
          ...params.InputProps,
          disableUnderline: true,
          endAdornment: null,
        }}
      />
    )}
    sx={{
      fontFamily: 'Poppins, sans-serif',
      '& .MuiOutlinedInput-root': {
        p: 1,
        height: 'fit-content',
        backgroundColor: 'rgba(243, 246, 249, 1)',
        fontSize: '0.75rem',
        display: 'flex',
        fontFamily: 'Poppins',
        border: 'none',
        alignItems: 'center',
        justifyContent: 'center',
        '& fieldset': {
          border: 'none',
        },
      },
      '& .MuiAutocomplete-popupIndicator': {
        display: 'none',
      },
      '& .MuiAutocomplete-tag': {
        bgcolor: 'rgba(240, 243, 199, 1)',
        color: 'rgba(187, 200, 8, 1)',
        border: 'none',
        borderColor: 'primary.light',
        fontSize: '0.75rem',
        padding: '2px 6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '2px',
      },
      '& .MuiAutocomplete-tag .MuiChip-deleteIcon': {
        color: 'rgba(187, 200, 8, 1)',
        '&:hover': {
          color: 'rgba(187, 200, 8, 1)',
        },
      },
    }}
    isOptionEqualToValue={(option, value) => option.label === value.label}
  />
</div>

              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  marginLeft: "1rem",
                }}
              >
                Nom
                <input
                  type="text"
                  className={classes.inputContainer}
                  style={{ width: "149px", marginLeft: "10px" }}
                  onChange={handleNomChange}
                />
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  marginLeft: "1rem",
                }}
              >
                Prénom
                <input
                  type="text"
                  className={classes.inputContainer}
                  style={{ width: "149px", marginLeft: "10px" }}
                  onChange={handlePrenomChange}
                />
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  marginLeft: "1rem",
                }}
              >
                Comptes verrouillés
                <StyledSwitch
                  checked={showLockedOnly}
                  onChange={handleLockedSwitchChange}
                  sx={{ ml: 1 }}
                />
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {/* <button
                className={classes.ExportStyle} 
                onClick={handleExport}
              >
                Export
              </button> */}
              <button
                className={classes.ajouterStyle} 
                   onClick={handleAddUser}
              >
                Ajouter
              </button>
            </div>
          </div>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
          >
            <thead>
              <tr>
                {headRows.map((row) => (
                  <TableCell
                    height={"43px"}
                    width={row.width}
                    align={row.align}
                    className={classes.tableHeadRows}
                    key={row.id}
                  >
                    {row.label}
                  </TableCell>
                ))}
              </tr>
            </thead>
            <tbody>
                {loading
                  ? [...Array(10)].map((_, index) => (
                      <tr key={index} style={{ height: "48px" }}>
                        <TableCell align="left" className={classes.tableCellSmall}>
                          <Skeleton animation="wave" />
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellSmall}>
                          <Skeleton animation="wave" />
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellSmall}>
                          <Skeleton animation="wave" />
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellSmall}>
                          <Skeleton animation="wave" />
                        </TableCell>
                        <TableCell align="center" className={classes.tableCellSmall}>
                          <Skeleton animation="wave" />
                        </TableCell>
                      </tr>
                    ))
                  : (
                    <>
                      {usersFilter != null && usersFilter.length > 0 ? (
                        usersFilter
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((user) => (
                            <tr key={user.id} style={{ height: "48px" }}>
                              <TableCell align="left" className={classes.tableCellSmall}>
                                {user.firstName + " " + user.lastName}
                              </TableCell>
                              <TableCell align="left" className={classes.tableCellSmall}>
                                {user.email || "N/A"}
                              </TableCell>
                              <TableCell align="left" className={classes.tableCellSmall}>
                                {user.phoneNumber || "N/A"}
                              </TableCell>
                              <TableCell align="left" className={classes.tableCellSmall}>
                                {user.userGroups.map((group, index) => (
                                  <span 
                                  style={{width: "69px",
                                    height: "26px", 
                                    borderRadius: '51px',
                                    background:'rgba(240, 243, 199, 1)',
                                    fontFamily: 'Poppins',
                                    fontSize: '10.69px',
                                    fontWeight: 500,
                                    lineHeight: '16.03px',
                                    textAlign: 'left',
                                    color:'rgba(60, 101, 86, 1)',
                                    padding :'10px',
                                    marginRight: '5px'}}
                                  key={index}>{group.label}</span>
                                ))}
                              </TableCell>
                              <TableCell align="right" className={classes.tableCellSmall}>
                                <button
                                  style={{
                                    width: "80px",
                                    height: "34px",
                                    borderRadius: "6px",
                                    background: "rgba(187, 200, 8, 1)",
                                    border: 0,
                                    fontFamily: "Poppins",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                    color: "rgba(255,255,255,1)",
                                    cursor: "pointer",
                                  }}
                                   onClick={() => handleEditUser(user)}
                                >
                                  Modifier
                                </button>
                                <button
                                  style={{
                                    width: "80px",
                                    height: "34px",
                                    borderRadius: "6px",
                                    background: "rgba(255, 229, 229, 1)",
                                    border: 0,
                                    fontFamily: "Poppins",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                    marginLeft: "10px",
                                    color: "rgba(255, 54, 54, 1)",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleClickDeleteOpen(user)}
                                >
                                  Supprimer
                                </button>
                                {user.accountLocked && (
                                  <button
                                    style={{
                                      width: "40px",
                                      height: "34px",
                                      borderRadius: "6px",
                                      background: "rgba(240, 243, 199, 1)",
                                      border: 0,
                                      fontFamily: "Poppins",
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      lineHeight: "18px",
                                      marginLeft: "10px",
                                      color: "rgba(60, 101, 86, 1)",
                                      cursor: "pointer",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      verticalAlign: "middle",
                                    }}
                                    onClick={() => handleOpenUnlockDialog(user)}
                                    title="Déverrouiller le compte"
                                  >
                                    <VpnKeyIcon style={{ fontSize: 18 }} />
                                  </button>
                                )}
                              </TableCell>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <TableCell
                            align="center"
                            style={{
                              fontFamily: 'Poppins',
                              fontWeight: 400,
                              fontSize:  15,
                              lineHeight: '22.5px',
                              color: 'rgba(70, 78, 95, 1)',
                              padding: '20px'
                            }}
                            colSpan="6"
                          >
                            Aucun utilisateur disponible
                          </TableCell>
                        </tr>
                      )}
                    </>
                  )}
              </tbody>
          </Table>
          <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={usersFilter?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                  "aria-label": "Previous Page",
                }}
                nextIconButtonProps={{
                  "aria-label": "Next Page",
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "18px",
                  color: "rgba(32, 18, 70, 1)",
                }}
                labelRowsPerPage="Lignes par page"
            />
        </div>
      </Paper>

          <Dialog
            open={open}
            onClose={handleCloseDialog}
            classes={{ paper: classes.dialogPaper }}
          >
            <DialogTitle
              className={classes.dialogTitle}
              style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}
            >
              {isEditing ? "Modification Utilisateur" : "Création Utilisateur"}
            </DialogTitle>
            <DialogContent>
            <Accordion allowMultiple defaultIndex={[0, 1, 2 , 3]}> {/* All panels open by default */}
              <AccordionItem>
                <AccordionButton
                  style={{
                    height: "47px",
                    border: "none",
                    background: "rgba(255, 255, 255, 1)",
                    borderBottom: "none",
                  }}
                >
                  <AccordionIcon
                    size="30px"
                    style={{
                      backgroundColor: "rgba(240, 243, 199, 1)",
                      width: "25px",
                      height: "25px",
                      borderRadius: "5px",
                      color: "rgba(60, 101, 86, 1)",
                    }}
                  />
                  <Box
                    as="div"
                    textAlign="left"
                    marginLeft="20px"
                    style={{
                      color: "rgba(0, 34, 38, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "21px",
                      fontFamily: "Poppins",
                    }}
                  >
                    Informations générales
                  </Box>
                </AccordionButton>
                <AccordionPanel>
                  <div style={{ marginLeft: "1rem" }}>
                   <div style={{display:"flex" ,justifyContent: "space-between"}}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label
                          className={classes.cardText}
                          style={{ marginBottom: "0.5rem" }}
                        >
                          Nom Utilisateur
                        </label>
                        <input
                          className={classes.styleInput}
                          value={firstName}
                          onChange={(e) => {
                            if (validateInput(e.target.value)) {
                              setFirstName(e.target.value);
                              setErrors([]);
                            } else {
                              setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                            }
                          }}
                        />
                        <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label
                          className={classes.cardText}
                          style={{ marginBottom: "0.5rem" }}
                        >
                          Prénom Utilisateur
                        </label>
                        
                         <input
                          className={classes.styleInput}
                          value={lastName}
                          onChange={(e) => {
                            if (validateInput(e.target.value)) {
                              setLastName(e.target.value);
                              setErrors([]);
                            } else {
                              setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                            }
                          }}
                        />
                        <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                      </div>
                   </div>
                   <div style={{display:"flex",justifyContent: "space-between" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label
                          className={classes.cardText}
                          style={{ marginBottom: "0.5rem" }}
                        >
                          N° Tél
                        </label>
                        <input
                          type="text"
                          className={classes.styleInput}
                          value={phoneNumber}
                          onChange = {handlePhoneNumberChange}
                          //onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label
                          className={classes.cardText}
                          style={{ marginBottom: "0.5rem" }}
                        >
                          Email
                        </label>
                        <input
                            type="email"
                          className={classes.styleInput}
                          value={email}
                          onChange={(e) => {
                            if (validateInput(e.target.value)) {
                              setEmail(e.target.value);
                              setErrors([]);
                            } else {
                              setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                            }
                          }}
                        />
                        <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                      </div>
                   </div>
                   {selectedUserEdit ?'':(<div style={{display:"flex",justifyContent: "space-between" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label
                          className={classes.cardText}
                          style={{ marginBottom: "0.5rem" }}
                        >
                          Identité
                        </label>
                        <input 
                          className={classes.styleInput}
                          value={identity}
                          onChange={(e) => {
                            if (validateInput(e.target.value)) {
                              setIdentity(e.target.value);
                              setErrors([]);
                            } else {
                              setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                            }
                          }}
                        />
                        <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                      </div>
                       
                   </div>)}
                  </div>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                  <AccordionButton
                    style={{
                      height: "47px",
                      border: "none",
                      background: "rgba(255, 255, 255, 1)",
                      borderBottom: "none",
                    }}
                  >
                    <AccordionIcon
                      size="30px"
                      style={{
                        backgroundColor: "rgba(240, 243, 199, 1)",
                        width: "25px",
                        height: "25px",
                        borderRadius: "5px",
                        color: "rgba(60, 101, 86, 1)",
                      }}
                    />
                    <Box
                      as="div"
                      textAlign="left"
                      marginLeft="20px"
                      style={{
                        color: "rgba(0, 34, 38, 1)",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "21px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Groups Utilisateur
                    </Box>
                  </AccordionButton>
              <AccordionPanel>
                <div style={{ marginLeft: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label className={classes.cardText} style={{ marginBottom: "0.5rem" }}>
                      Groupe Utilisateur
                    </label>
                    <Autocomplete
                      multiple
                      id="TypologieGroupe"
                      options={userGroups}
                      value={selectedGroup}
                      size="small"
                      onChange={handleGroupsChange}  
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => (
                        <li {...props} className={`${props.className} ${classes.optionItem}`}>
                          {option.label}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            placeholder: selectedGroup && selectedGroup.length<1 ?'Groupe Utilisateur':'',
                            endAdornment: null,
                            classes: {
                              root: classes.selectInputDialog,
                            },
                          }}
                        />
                      )}
                      sx={{
                        fontFamily: 'Poppins, sans-serif',
                        '& .MuiOutlinedInput-root': {
                          p: 1,
                          height: 'fit-content',
                          backgroundColor: 'rgba(243, 246, 249, 1)',
                          fontSize: '0.75rem',
                          display: 'flex',
                          fontFamily: 'Poppins',
                          border: 'none',
                          alignItems: 'center',
                          justifyContent: 'center',
                          '& fieldset': {
                            border: 'none',
                          },
                        },
                        '& .MuiAutocomplete-popupIndicator': {
                          display: 'none',
                        },
                        '& .MuiAutocomplete-tag': {
                          bgcolor: 'rgba(240, 243, 199, 1)',
                          color: 'rgba(60, 101, 86, 1)',
                          border: 'none',
                          borderColor: 'primary.light',
                          fontSize: '0.75rem',
                          padding: '2px 6px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '2px',
                        },
                        '& .MuiAutocomplete-tag .MuiChip-deleteIcon': {
                          color: 'rgba(60, 101, 86, 1)',
                          '&:hover': {
                            color: 'rgba(60, 101, 86, 1)',
                          },
                        },
                      }}
                      isOptionEqualToValue={(option, value) => option.label === value.label}
                    />
                  </div>

                  
                </div>
              </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionButton
                  style={{
                    height: "47px",
                    border: "none",
                    background: "rgba(255, 255, 255, 1)",
                    borderBottom: "none",
                  }}
                >
                  <AccordionIcon
                    size="30px"
                    style={{
                      backgroundColor: "rgba(240, 243, 199, 1)",
                      width: "25px",
                      height: "25px",
                      borderRadius: "5px",
                      color: "rgba(60, 101, 86, 1)",
                    }}
                  />
                  <Box
                    as="div"
                    textAlign="left"
                    marginLeft="20px"
                    style={{
                      color: "rgba(0, 34, 38, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "21px",
                      fontFamily: "Poppins",
                    }}
                  >
                    Visibilité sinistre utilisateur
                  </Box>
                </AccordionButton>
                <AccordionPanel>
                  <div style={{ marginLeft: "1rem" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label className={classes.cardText} style={{ marginBottom: "0.5rem" }}>
                        Typologie de sinistre
                      </label>
                      <Autocomplete
                          multiple
                          id="Typologie"
                          options={managementTypes}
                          value={selectedDAAQs}
                          size="small"
                          onChange={handleDAAQChange}  
                          getOptionLabel={(option) => option.label}
                          renderOption={(props, option) => (
                            <li {...props} className={`${props.className} ${classes.optionItem}`}>
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                disableUnderline: true,
                                placeholder: selectedDAAQs && selectedDAAQs.length<1 ?'Typologie de sinistre':'',
                                endAdornment: null,
                                classes: {
                                  root: classes.selectInputDialog,
                                },
                              }}
                            />
                          )}
                          sx={{
                            fontFamily: 'Poppins, sans-serif',
                            '& .MuiOutlinedInput-root': {
                              p: 1,
                              height: 'fit-content',
                              backgroundColor: 'rgba(243, 246, 249, 1)',
                              fontSize: '0.75rem',
                              display: 'flex',
                              fontFamily: 'Poppins',
                              border: 'none',
                              alignItems: 'center',
                              justifyContent: 'center',
                              '& fieldset': {
                                border: 'none',
                              },
                            },
                            '& .MuiAutocomplete-popupIndicator': {
                              display: 'none',
                            },
                            '& .MuiAutocomplete-tag': {
                              bgcolor: 'rgba(240, 243, 199, 1)',
                              color: 'rgba(60, 101, 86, 1)',
                              border: 'none',
                              borderColor: 'primary.light',
                              fontSize: '0.75rem',
                              padding: '2px 6px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              margin: '2px',
                            },
                            '& .MuiAutocomplete-tag .MuiChip-deleteIcon': {
                              color: 'rgba(60, 101, 86, 1)',
                              '&:hover': {
                                color: 'rgba(60, 101, 86, 1)',
                              },
                            },
                          }}
                          isOptionEqualToValue={(option, value) => option.label === value.label}
                        />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label className={classes.cardText} style={{ marginBottom: "0.5rem" }}>
                        Agence de sinistre
                      </label>
                      <Autocomplete
                      multiple
                      id="Agency"
                      options={agencies}
                      value={selectedAgencies}
                      size="small"
                      onChange={handleAgencyChange}
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          className={`${props.className} ${classes.optionItem}`}
                        >
                          {option.label}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            placeholder:selectedAgencies&& selectedAgencies.length<1 ?'Typologie de sinistre':'',
                            endAdornment: null,
                            classes: {
                              root: classes.selectInputDialog,
                            },
                          }}
                        />
                      )}
                      sx={{
                        fontFamily: "Poppins, sans-serif",
                        "& .MuiOutlinedInput-root": {
                          p: 1,
                          height: "fit-content",
                          backgroundColor: "rgba(243, 246, 249, 1)",
                          fontSize: "0.75rem",
                          display: "flex",
                          fontFamily: "Poppins",
                          border: "none",
                          alignItems: "center",
                          justifyContent: "center",
                          "& fieldset": {
                            border: "none",
                          },
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          display: "none",
                        },
                        "& .MuiAutocomplete-tag": {
                          bgcolor: "rgba(240, 243, 199, 1)",
                          color: "rgba(60, 101, 86, 1)",
                          border: "none",
                          borderColor: "primary.light",
                          fontSize: "0.75rem",
                          padding: "2px 6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "2px",
                        },
                        "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                          color: "rgba(60, 101, 86, 1)",
                          "&:hover": {
                            color: "rgba(60, 101, 86, 1)",
                          },
                        },
                      }}
                      isOptionEqualToValue={(option, value) => option.label === value.label}

                    />
                    </div>
                  </div>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <AccordionButton
                  style={{
                    height: "47px",
                    border: "none",
                    background: "rgba(255, 255, 255, 1)",
                    borderBottom: "none",
                  }}
                >
                  <AccordionIcon
                    size="30px"
                    style={{
                      backgroundColor: "rgba(240, 243, 199, 1)",
                      width: "25px",
                      height: "25px",
                      borderRadius: "5px",
                      color: "rgba(60, 101, 86, 1)",
                    }}
                  />
                  <Box
                    as="div"
                    textAlign="left"
                    marginLeft="20px"
                    style={{
                      color: "rgba(0, 34, 38, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "21px",
                      fontFamily: "Poppins",
                    }}
                  >
                    Habilitation utilisateur
                  </Box>
                </AccordionButton>
                <AccordionPanel>
                  <div style={{ marginLeft: "1rem" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label className={classes.cardText} style={{ marginBottom: "0.5rem" }}>
                        Autorités du groupe
                      </label>
                      <Autocomplete
                        multiple
                        id="Authorities"
                        options={authorities}
                        value={selectedAuthorities}
                        size="small"
                        onChange={handleAuthorityChange}
                        getOptionLabel={(option) =>
                          translateAuthorities(option.label)
                        }
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            className={`${props.className} ${classes.optionItem}`}
                          >
                            {translateAuthorities(option.label)}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              disableUnderline: true,
                              placeholder: selectedAuthorities&& selectedAuthorities.length<1 ?'Typologie de sinistre':'',
                              endAdornment: null,
                              classes: {
                                root: classes.selectInputDialog,
                              },
                            }}
                          />
                        )}
                        sx={{
                          fontFamily: "Poppins, sans-serif",
                          "& .MuiOutlinedInput-root": {
                            p: 1,
                            height: "fit-content",
                            backgroundColor: "rgba(243, 246, 249, 1)",
                            fontSize: "0.75rem",
                            display: "flex",
                            fontFamily: "Poppins",
                            border: "none",
                            alignItems: "center",
                            justifyContent: "center",
                            "& fieldset": {
                              border: "none",
                            },
                          },
                          "& .MuiAutocomplete-popupIndicator": {
                            display: "none",
                          },
                          "& .MuiAutocomplete-tag": {
                            bgcolor: "rgba(240, 243, 199, 1)",
                            color: "rgba(60, 101, 86, 1)",
                            border: "none",
                            borderColor: "primary.light",
                            fontSize: "0.75rem",
                            padding: "2px 6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "2px",
                          },
                          "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                            color: "rgba(60, 101, 86, 1)",
                            "&:hover": {
                              color: "rgba(60, 101, 86, 1)",
                            },
                          },
                        }}
                        isOptionEqualToValue={(option, value) => option.label === value.label}

                      />
                    </div>
                  </div>
                </AccordionPanel>
              </AccordionItem> 

            </Accordion>

            </DialogContent>
            <DialogActions>
              <Button style={{
                                    fontFamily: 'Poppins',
                                    fontSize: '10.76px',
                                    fontWeight: 600,
                                    lineHeight: '16.14px',
                                    textAlign: 'left',
                                    color: 'rgba(255, 54, 54, 1)',
                                    background: 'rgba(255, 229, 229, 1)',
                                    width: '62px',
                                    height: '26px',
                                    borderRadius: '5.38px',
                                    marginRight: '10px',
                                    '&:hover': {
                                        background: 'rgba(255, 229, 229, 1)',
                                    },
                                }}onClick={handleCloseDialog} color="secondary">
                Annuler
              </Button>
              <Button  style={{
                                    fontFamily: 'Poppins',
                                    fontSize: '10.76px',
                                    fontWeight: 600,
                                    lineHeight: '16.14px',
                                    textAlign: 'left',
                                    color: 'rgba(255, 255, 255, 1)',
                                    background: 'rgba(60, 101, 86, 1)',
                                    width: '61.08px',
                                    height: '26.71px',
                                    borderRadius: '5.38px',
                                    marginRight: "10px",
                                    '&:hover': {
                                        background: 'rgba(60, 101, 86, 1)',
                                    },
                                }}
                                onClick={isEditing ? handleSubmitEdit: handleSubmitAdd}
                                color="primary">
                {isEditing ? "Modifier" : "Valider"}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openConfirm}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleCloseConfirm}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle
            className={classes.dialogTitle}
            style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}
            >
            {"Confirmation de suppression"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText
                id="alert-dialog-slide-description"
                style={{
                fontFamily: "Poppins",
                fontSize: "16px",
                }}
            >
                Êtes-vous sûr de supprimer le utilisateur <br />«{" "}
                {userToDelete?.firstName}{" "}{userToDelete?.lastName} »
                <br /> 
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button
                onClick={handleCloseConfirm}
                style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                lineHeight: "16.14px",
                textAlign: "left",
                color: "rgba(255, 255, 255, 1)",
                background: "rgba(60, 101, 86, 1)",
                width: "fit-content",
                height: "26px",
                borderRadius: "5.38px",
                marginRight: "10px",
                }}
            >
                Annuler
            </Button>
            <Button
                onClick={handleConfirmDelete}
                style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                lineHeight: "16.14px",
                textAlign: "left",
                color: "rgba(255, 54, 54, 1)",
                background: "rgba(255, 229, 229, 1)",
                width: "fit-content",
                height: "26.71px",
                borderRadius: "5.38px",
                marginRight: "10px",
                }}
            >
                Supprimer
            </Button>
            </DialogActions>
          </Dialog>

       <Dialog
          open={openUnlockDialog}
          onClose={handleCloseUnlockDialog}
          classes={{ paper: classes.dialogPaper }}
        >
          <DialogTitle
            className={classes.dialogTitle}
            style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}
          >
            Déverrouiller le compte
          </DialogTitle>
          <DialogContent>
            <Accordion allowMultiple defaultIndex={[0]}>
              <AccordionItem>
                <AccordionButton
                  style={{
                    height: "47px",
                    border: "none",
                    background: "rgba(255, 255, 255, 1)",
                    borderBottom: "none",
                  }}
                >
                  <AccordionIcon
                    size="30px"
                    style={{
                      backgroundColor: "rgba(240, 243, 199, 1)",
                      width: "25px",
                      height: "25px",
                      borderRadius: "5px",
                      color: "rgba(60, 101, 86, 1)",
                    }}
                  />
                  <Box
                    as="div"
                    textAlign="left"
                    marginLeft="20px"
                    style={{
                      color: "rgba(0, 34, 38, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "21px",
                      fontFamily: "Poppins",
                    }}
                  >
                    Déverrouillage du compte
                  </Box>
                </AccordionButton>
                <AccordionPanel>
                  <div style={{ marginLeft: "1rem" }}>
                    <div
                      style={{
                        marginBottom: "1rem",
                        fontFamily: "Poppins",
                        fontSize: "13px",
                        color: "rgba(70, 78, 95, 1)",
                      }}
                    >
                      Ce compte est actuellement verrouillé. En confirmant, le
                      compte sera débloqué et le nombre de tentatives sera
                      réinitialisé. Un email avec le nouveau mot de passe sera envoyé à l'utilisateur.
                    </div>
                  </div>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                lineHeight: "16.14px",
                textAlign: "left",
                color: "rgba(255, 54, 54, 1)",
                background: "rgba(255, 229, 229, 1)",
                width: "62px",
                height: "26px",
                borderRadius: "5.38px",
                marginRight: "10px",
              }}
              onClick={handleCloseUnlockDialog}
              color="secondary"
            >
              Annuler
            </Button>
            <Button
              style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                lineHeight: "16.14px",
                textAlign: "left",
                color: "rgba(255, 255, 255, 1)",
                background: "rgba(60, 101, 86, 1)",
                width: "80px",
                height: "26.71px",
                borderRadius: "5.38px",
                marginRight: "10px",
              }}
              onClick={handleConfirmUnlock}
              color="primary"
            >
              Confirmer
            </Button>
          </DialogActions>
        </Dialog>

          {isRequestInProgress && (
                <div
                    style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",  // Center vertically
                    }}
                >
                    <div
                    style={{
                        background: "#fff",
                        padding: "20px",
                        borderRadius: "8px",
                        textAlign: "center",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        display: "flex",           // Use flexbox
                        flexDirection: "column",   // Stack the loader and text vertically
                        justifyContent: "center",  // Vertically center content inside the box
                        alignItems: "center",      // Horizontally center content inside the box
                    }}
                    >
                    <div className="spinner" style={{ marginBottom: "10px" }}></div>  {/* Optional margin between loader and text */}
                    <p style={{ fontFamily: "Poppins", fontSize: "16px", margin: 0 }}>
                        Veuillez patienter...
                    </p>
                    </div>
                </div>
            )}
    </div>
  );
}
